"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateBuffered = generateBuffered;
exports.asyncBuffer = asyncBuffer;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

var _queue = require("../../internal/queue");

async function* generateBuffered(source, n) {
  const iterator = (0, _asyncIterable.asyncify)(source)[Symbol.asyncIterator]();
  const buffer = new _queue.Queue();

  try {
    for (let i = 0; i < n; i++) {
      buffer.push(iterator.next());
    }

    yield 'primed';

    while (true) {
      buffer.push(iterator.next());
      const {
        done,
        value
      } = await buffer.shift();
      if (done) return;
      yield value;
    }
  } finally {
    if (typeof iterator.return === 'function') await iterator.return();
  }
}

async function* asyncBuffer(source, n) {
  const bufferGen = generateBuffered(source, n)[Symbol.asyncIterator]();
  await bufferGen.next();
  yield* bufferGen;
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncBuffer, {
  validateArgs([n]) {
    if (typeof n !== 'number' || n <= 0) {
      throw new Error('The first argument (bufferSize) should be a number greater than 0');
    }
  }

});

exports.default = _default;